import React from "react";

import Button from "../button/Button";
import useCustomCTA from "../../hooks/useCustomCTA";

function ActionsContact() {
  const defaultCTA = {
    text: "Ready to make your SaaS Scalable?",
    link: "https://accesto.com/contact/",
    btnText: "CONTACT US",
  };
  const { text, link, btnText } = useCustomCTA() ?? defaultCTA;

  return (
    <div className="actions__contact">
      <h2 className="actions__contact__heading">{text}</h2>
      <Button primary href={link}>
        {btnText}
      </Button>
    </div>
  );
}

export default ActionsContact;
